import { useCallback } from 'react';
import type { Locale } from '@enmon/commons';
import { useActiveUser } from '@/containers/App';
import { useUpdateMe } from '@/services/hooks/users/useUpdateMe';
import { useLocaleState } from './useLocaleState';

export const useChangeLocale = () => {
  const { locale, setLocale } = useLocaleState();
  const { mutate: changeUserLocale } = useUpdateMe();
  // useActiveUser used to avoid the "User not found" error
  const user = useActiveUser();

  const changeLocale = useCallback(
    (newLocale: Locale) => {
      if (newLocale) {
        setLocale(newLocale);
        if (user) {
          changeUserLocale({ locale: newLocale });
        }
      }
    },
    [setLocale, user, changeUserLocale],
  );

  return { locale, changeLocale };
};
